import _ from 'lodash';
import request from 'superagent';
import { receiveError as receivePacerError } from './pacerSearch';
import * as types from '../actionTypes/historyTypes';
import * as docketActionTypes from '../actionTypes/docketsActionTypes';

function mapResponseErrorsToMessage(err) {
  const request_id = _.get(err, ['response', 'body', 'error', 'request_id']);
  const errorMessageExtra = request_id
    ? `When contacting support, please quote Request ID '${request_id}'`
    : '';

  return {
    // We want to hide real messages from user since traces are confusing to them
    // TODO: coordinate with API to surface proper errors such as field validation?
    messages: [
      'PACER is experiencing some issues. Please try again in a few minutes.',
      errorMessageExtra,
    ],
    // but we include the real message in the details so we receive it in the sentry report
    details: _.get(err, ['response', 'body', 'error']) || [],
  };
}

function receiveError(err, msg) {
  return {
    type: types.SERVICE_ERROR,
    error: msg,
    errors: msg,
  };
}

function onFailure(dispatch) {
  return function (err) {
    return dispatch(receiveError(types.SERVICE_ERROR, mapResponseErrorsToMessage(err)));
  };
}
function requestCaseData(params, dispatch) {
  dispatch({
    type: types.REQUEST_HISTORY_DATA,
    params,
  });

  dispatch({
    type: types.RESET_SERVICE_ERROR,
  });
}

function requestFilterCaseData(params, dispatch) {
  dispatch({
    type: types.REQUEST_FILTER_HISTORY_DATA,
    params,
  });

  dispatch({
    type: types.RESET_SERVICE_ERROR,
  });
}

function mapHistoryDocumentsPacerResponseToData(response) {
  const history = response.body.items;
  history.entries = history.history || [];
  history.total_items = history.history.length;

  delete history.history;
  delete history.receipts;
  delete history.headers;

  return Object.keys(history).map(key => [key, history[key]]);
}

function receiveHistoryDocumentsFromPacer(response, filters) {
  const data = mapHistoryDocumentsPacerResponseToData(response, filters);

  return {
    type: types.RECEIVE_CASE_DATA,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []), // old
    lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
    receipt: _.get(response.body, 'items.receipts[0].text'),
  };
}

function mapHistoryDocumentsToData(response, filters) {
  const history = response.body;
  history.entries = history.json_data || [];
  history.entries.forEach(p => p.isVisible = true);
  if (filters.delimeter === ',') {
    history.entries.map(item => (item.text.docket_no === parseInt(filters.doc_from) || item.text.docket_no === parseInt(filters.doc_to)) ? item.isVisible = true : item.isVisible = false);
  }
  delete history.json_data;
  return Object.keys(history).map(key => [key, history[key]]);
}

function receiveHistoryDocuments(response, filters, receipts) {
  const data = mapHistoryDocumentsToData(response, filters);
  
  return {
    type: types.RECEIVE_HISTORY_DATA,
    data_type: filters.type,
    data,
    // data: _.get(response.body, `${filters.type}.text`, []), // old
    lastUpdated: receipts ? receipts.lastUpdated : null,
    receipt: receipts ? receipts.receipt : null,
  };
}

export const filterHistoryEntries = (filter) => (dispatch, getState) => {
  requestFilterCaseData({}, dispatch);

  const state = getState();

  const { keyword = '' } = filter;
  const searchWords = keyword.toLowerCase().split(' ').filter(p => p !== '').reverse();

  const data = state.toJS().history.data.map((next) => {
    const key = next[0];
    const value = next[1];

    if (key === 'entries') {
      const values = value.map((docketEntry) => {
        const docketText = _.get(docketEntry, ['text', 'docket_text'], '');
        const isVisible = _.isEmpty(searchWords) || _.every(searchWords, word => docketText.toLowerCase().indexOf(word) > -1);
        return { ...docketEntry, isVisible };
      });
      return [key, values];
    }
    return next;
  });

  return dispatch({
    type: types.RECEIVE_HISTORY_DATA,
    data_type: 'history',
    data,
  });
}
export const getParserSearchData = (params, receipts) => (dispatch) => {
  dispatch({
    type: docketActionTypes.UPDATE_SELECTED_DOCKET,
    selectedDocket: {
      status: 'done',
      docket_no: null,
      docket_seq: null,
      binder: {},
    },
  });

  requestCaseData(params, dispatch);
    //optional params after direction add page size
  return request
    .post(`/parser/direct/history_search/${params.case_uuid}/${params.keyword}/${params.date_from}/${params.date_to}/${params.doc_from}/${params.doc_to}/${params.sort_field}/${params.sort_direction}?page=${params.page_num}`)
    .set('Accept', 'application/json')
    .then(
      response => dispatch(receiveHistoryDocuments(response, params, receipts)),
      onFailure(dispatch),
    );
};


export const getHistoryItems = (
  params,
  receipts = null,
) => function (dispatch, getState) {
  // requestCaseData({}, dispatch);
  dispatch({
    type: docketActionTypes.UPDATE_SELECTED_DOCKET,
    selectedDocket: {
      status: 'done',
      docket_no: null,
      docket_seq: null,
      binder: {},
    },
  });

  return request
  .post(`/parser/direct/history_search/${params.case_uuid}/${params.keyword}/${params.date_from}/${params.date_to}/${params.doc_from}/${params.doc_to}/${params.sort_field}/${params.sort_direction}?page=${params.page_num}`)
  .set('Accept', 'application/json')
  .then(
    response => dispatch(receiveHistoryDocuments(response, params, receipts)),
    onFailure(dispatch),
  );
}
export const purchaseHistoryCaseData = params => (dispatch) => {
  requestCaseData(params, dispatch);

  return request
    .get('/ir-search/pacer-query-json')
    .query({
      query: params.type,
      case_uuid: params.case_uuid,
      history_type: params.history_type,
      show_docket: params.show_docket,
    })
    .set('Accept', 'application/json')
    .then(
      (response) => {
        window.refresh_menu(params.case_uuid);

        if (!_.isEmpty(response.body.error)) {
          return onFailure(dispatch)({ response });
        }
        const itemParams = {
          case_uuid: params.case_uuid,
          date_from: '_',
          date_to: '_',
          doc_from: '_',
          doc_to: '_',
          keyword: '_',
          page_num: 0,
          page_index: 1,
          sort_direction: 'desc',
          sort_field: 'date_filed',
        };


        const receipts = {
          receipt: _.get(response.body, 'items.receipts[0].text'),
          lastUpdated: _.get(response.body, 'items.receipts[0].meta.timestamp'),
        };

        return getParserSearchData(
          itemParams,
          receipts,
        )(dispatch);
      },
      onFailure(dispatch),
    );
};


// WEBPACK FOOTER //
// ./src/redux/actions/historyActions.js